import { render, staticRenderFns } from "./SystemUsers.vue?vue&type=template&id=67f16130&scoped=true&"
import script from "./SystemUsers.vue?vue&type=script&lang=ts&"
export * from "./SystemUsers.vue?vue&type=script&lang=ts&"
import style0 from "./SystemUsers.vue?vue&type=style&index=0&id=67f16130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f16130",
  null
  
)

export default component.exports